import React from 'react';

import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import {
  CreateInvoiceNote,
  CreateInvoiceNoteVariables,
} from 'ap/paymentCycle/view/TransactionModal/TransactionDetail/ActionMenu/__generated__/CreateInvoiceNote';

import ADD_NEW_NOTE from './NoteSupplierCreate.graphql';

type SupplierNotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  supplierId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const SupplierNotesSection: React.FC<SupplierNotesProps> = ({
  supplierId,
  data,
  listRefreshRequest,
  loading,
}) => {
  return (
    <GenericNotesSection<any, CreateInvoiceNote, CreateInvoiceNoteVariables>
      entityId={supplierId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
